import React from "react";

export const LadderInfoIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.32"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.941 5.48455C12.9811 5.72598 11.8479 5.74202 10.869 5.44298C10.4552 5.31655 10.1325 4.99418 9.99286 4.58465C9.64493 3.56443 9.55898 2.31567 9.8147 1.35445C9.28527 1.34116 8.68323 1.33325 8 1.33325C5.67717 1.33325 4.29297 1.42447 3.50857 1.50911C2.92744 1.57182 2.47934 1.96543 2.37054 2.5397C2.20117 3.43362 2 5.10475 2 7.99992C2 10.8951 2.20117 12.5662 2.37054 13.4602C2.47934 14.0344 2.92744 14.428 3.50857 14.4907C4.29297 14.5754 5.67717 14.6666 8 14.6666C10.3228 14.6666 11.707 14.5754 12.4914 14.4907C13.0726 14.428 13.5207 14.0344 13.6295 13.4602C13.7988 12.5662 14 10.8951 14 7.99992C14 7.02959 13.9774 6.19672 13.941 5.48455ZM5.33333 8.66659C4.96513 8.66659 4.66667 8.36812 4.66667 7.99992C4.66667 7.63172 4.96513 7.33325 5.33333 7.33325H8C8.3682 7.33325 8.66667 7.63172 8.66667 7.99992C8.66667 8.36812 8.3682 8.66659 8 8.66659H5.33333ZM5.33333 11.6666C4.96513 11.6666 4.66667 11.3681 4.66667 10.9999C4.66667 10.6317 4.96513 10.3333 5.33333 10.3333H10C10.3682 10.3333 10.6667 10.6317 10.6667 10.9999C10.6667 11.3681 10.3682 11.6666 10 11.6666H5.33333Z"
      fill="#078DEE"
    />
    <path
      d="M4.66663 11C4.66663 11.3682 4.96509 11.6667 5.33329 11.6667H9.99996C10.3682 11.6667 10.6666 11.3682 10.6666 11C10.6666 10.6318 10.3682 10.3333 9.99996 10.3333H5.33329C4.96509 10.3333 4.66663 10.6318 4.66663 11Z"
      fill="#078DEE"
    />
    <path
      d="M4.66663 8C4.66663 8.3682 4.96509 8.66667 5.33329 8.66667H7.99996C8.36816 8.66667 8.66663 8.3682 8.66663 8C8.66663 7.6318 8.36816 7.33333 7.99996 7.33333H5.33329C4.96509 7.33333 4.66663 7.6318 4.66663 8Z"
      fill="#078DEE"
    />
    <path
      d="M13.9409 5.48463C12.9811 5.72607 11.8478 5.7421 10.869 5.44307C10.4552 5.31663 10.1325 4.99427 9.99283 4.58473C9.64489 3.5645 9.55893 2.31571 9.81466 1.35449C9.81466 1.35449 10.6307 1.66663 12.1307 3.16663C13.6307 4.66663 13.9409 5.48463 13.9409 5.48463Z"
      fill="#078DEE"
    />
  </svg>
);
